import FiltersIcon from '../../../../../assets/FiltersIcon.svg'
import { Button } from '../../../../cta_utils/AnButton'
import AnPopup from '../../../../cta_utils/AnPopup'
import { AnInputBox } from '../../../../input_utils/AnInput'
import { useMapperFilterContext } from '../../../new_temp_mapper/contexts/mapper_filter_context'
import { ALL_MAPPER_FILTER_ACTIONS, initialrange_filterFilter, maxConfidenceRange, minConfidenceRange } from '../FiltersStateReducer'
import filtersIcon from "../../../../../assets/FiltersIcon.svg"
import { CONDITIONS } from '../MapperSuggestionUtils'
import { useMemo, useState } from 'react'
import ConditionalRender from '../../../../../ConditionalRender'
import { setState } from '../../../../utils/CommonReducer'
import { CommonRangeFilter } from '../../CommonRangeFilter'
const RangeFilter = ({
    rangeLabel,
    toggleDropDown,
    ...props
}) => {
    const { filtersState, filtersStateReducer } = useMapperFilterContext();
    const {range_filter} = filtersState
    const [popupsList, setPopupsList] = useState({});
    const handlePopupClose = () => setPopupsList({})
    const handleFilterApply = () => {
        let temp_range = {min: range_filter.min, max: range_filter.max}
        setState(filtersStateReducer)({range: temp_range})
        handlePopupClose()
        toggleDropDown()
    }
    const renderRangeFilterPopup = () => {
        return (
            <AnPopup name="RangeFilterPopup" handleOnClosePopup={handlePopupClose} maxWidth={370}>
                <div className="text_title">
                    {rangeLabel()}
                </div>
                <div className="line_seperator_ex_light_grey" style={{ margin: "16px 0px" }}></div>
                <CommonRangeFilter range_filter={range_filter} minRange={minConfidenceRange} maxRange={maxConfidenceRange} setRangeFilter={(new_range_filter) => setState(filtersStateReducer)({ range_filter: new_range_filter })}/>
                <div className="line_seperator_ex_light_grey" style={{ margin: "16px 0px" }}></div>
                <div className='flex_container_space_between'>
                    <div style={{ display: "flex" }}>
                        <Button
                            buttonSize="Medium"
                            type="Secondary"
                            innerButtonStye={{ padding: "8px 28px" }}
                            onClick={handlePopupClose}
                        >
                            Cancel
                        </Button>
                        <Button
                            buttonSize="Medium"
                            innerButtonStye={{ padding: "8px 30px" }}
                            buttonStyle={{ marginLeft: 12 }}
                            onClick={handleFilterApply}
                            isLoading={false}
                        >
                            Apply
                        </Button>

                    </div>
                </div>
            </AnPopup>
        )
    }
    return (
        <div>
            <div className='filter_item_container' style={{ cursor: 'pointer' }} onClick={() => setPopupsList({ rangeFilterPopup: true })}>
                <div className='default_flex_container' style={{ padding: "12px 16px 16px" }}>
                    <div className='circle_image_background' style={{ width: 24, height: 24 }}>
                        <img className="circle_image" style={{width: 14, height: 14}} src={filtersIcon}></img>
                    </div>
                    <div className='text_body_light' style={{ marginLeft: 4 }}>Enter Manually</div>
                </div>
            </div>
            {popupsList.rangeFilterPopup && renderRangeFilterPopup()}
        </div>
    )
}

export default RangeFilter